import React from 'react';
const causes = [{
  emoji: '🦠',
  label: 'CAUSA 1 — EL BIOFILM ACTIVO',
  text: 'El hongo construye una fortaleza protectora. Los medicamentos no pueden penetrarla.'
}, {
  emoji: '🫁',
  label: 'CAUSA 2 — EL INTESTINO DAÑADO',
  text: 'El 70% de los casos tiene origen intestinal. El intestino re-infecta la vagina cada mes.'
}, {
  emoji: '🍬',
  label: 'CAUSA 3 — LA ALIMENTACIÓN',
  text: 'Cada gramo de azúcar es combustible directo para el hongo que querés eliminar.'
}];
export function TriangleSection() {
  return <section className="w-full bg-brand-gray px-6 py-16" data-id="element-294">
      <div className="max-w-4xl mx-auto" data-id="element-295">
        <h2 className="text-[28px] font-bold text-brand-text text-center mb-2 leading-tight" data-id="element-296">
          LAS 3 CAUSAS QUE NADIE TRATA JUNTAS
        </h2>
        <p className="text-brand-muted text-center text-[16px] mb-12" data-id="element-297">
          Por qué te vuelve una y otra vez
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10" data-id="element-298">
          {causes.map((cause, i) => <div key={i} className="bg-white rounded-[16px] p-6 shadow-[0_4px_24px_rgba(0,0,0,0.08)] flex flex-col items-center text-center" data-id="element-299">
              <span className="text-4xl mb-4 block" data-id="element-300">{cause.emoji}</span>
              <p className="text-brand-text text-[15px] font-bold uppercase tracking-wide mb-3" data-id="element-301">
                {cause.label}
              </p>
              <p className="text-[15px] text-brand-muted leading-relaxed" data-id="element-302">
                {cause.text}
              </p>
            </div>)}
        </div>

        <p className="text-[18px] text-brand-text text-center font-bold" data-id="element-303">
          El Método pH-ZERO ataca las 3 causas al mismo tiempo.
        </p>
      </div>
    </section>;
}